import { SDKConfiguration } from "../setup/config";

export async function logger(object: object) {
  fetch(`${SDKConfiguration.API_ENDPOINT}/api/log`, {
    method: "POST",
    body: JSON.stringify({ object }),
  })
    .then((e) => e.json())
    .then(console.log);
}
